<template>
  <div class="form-group filter-item" @click="clearErrors">
    <label class="control-label">{{ filter.label }}</label>
    <b-form-tags
      v-model="tags"
      @input="handleChange"
      :class="{'has-errors': filter.errors}"
    >
      <template #add-button-text>
        <feather-icon icon="PlusIcon" size="12"></feather-icon>
      </template>
    </b-form-tags>
    <div v-for="error in filter.errors" class="filter-error">
      {{ error }}
    </div>
  </div>
</template>
<script>
import { BFormTags } from 'bootstrap-vue'

export default {
  props: ['filter'],
  components: {
    BFormTags,
  },
  data(){
    return {
      tags: JSON.parse(JSON.stringify(this.filter.value || []))
    }
  },
  methods: {
    handleChange($event) {
      let value = $event

      if (!$event.length) {
        value = null
      }

      this.$set(this.filter, 'value', value);

      this.$emit('option:deselected', true);
      this.$emit('value-updated');
    },
    clearErrors() {
      if (this.filter.errors) {
        this.$delete(this.filter, 'errors')
      }
    }
  },
  watch: {
    'filter.value': function (val){
      if (!val) {
        this.tags = null
      }
    }
  }
}
</script>
